import { DashboardLayout } from '../../components/DashboardLayout';
import { Bell } from '@phosphor-icons/react';

export default function CreatorBrandEnquiriesPage() {
  return (
    <DashboardLayout>
      <div className="space-y-5" data-testid="creator-brand-enquiries">
        <div>
          <h1 className="font-display text-2xl font-black text-[var(--text-primary)] tracking-tight">Brand Enquiries</h1>
          <p className="text-sm text-[var(--text-secondary)] mt-1">Inbound partnership requests from brands who discovered your Marketplace Card</p>
        </div>
        <div className="nx-metric-card rounded-md text-center py-12">
          <Bell size={40} className="mx-auto mb-3 text-[var(--text-tertiary)]" />
          <p className="text-sm text-[var(--text-primary)] mb-1">No brand enquiries yet</p>
          <p className="text-xs text-[var(--text-secondary)]">When brands find your Marketplace Card and send a connection request, it appears here. Improve your SoM score to get discovered.</p>
        </div>
      </div>
    </DashboardLayout>
  );
}
